import { axiosInstance } from "@/lib/axios";
import { MODEL_PATH, type InteractionModel } from "@/features/interactions/models";

export type WatchlistableModel = InteractionModel;

/**
 * `modelId` is a string as well as a number on purpose — see toggleLike in
 * features/likes/api.ts for why drops have no numeric id to pass here, and
 * features/interactions/models.ts for where the path segment comes from.
 */
export async function toggleWatchlist(
  modelType: WatchlistableModel,
  modelId: number | string,
  action: boolean
): Promise<any> {
  const { data } = await axiosInstance.post(
    `/watchlist/${MODEL_PATH[modelType]}/${encodeURIComponent(String(modelId))}`,
    { action },
  );
  return data;
}
